import { FormlyFieldConfig } from '@ngx-formly/core';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function addonsExtension(field: FormlyFieldConfig) {
  if (!field.templateOptions || (field.wrappers && field.wrappers.indexOf('addons') !== -1)) {
    return;
  }

  if (field.templateOptions.addonLeft || field.templateOptions.addonRight) {
    field.wrappers = [...(field.wrappers || []), 'addons'];
  }
}
